/**
 * @param {import('react-router-dom').NavigateFunction} navigate - The navigate function
 * @param {Function} onBack - The onBack function
 * @returns {void}
 */
export const handleBack = (navigate, onBack) => {
    const search = new URLSearchParams(window.location.search);
    const backUrl = search.get('backUrl');
    if (backUrl) {
        navigate(backUrl, { replace: true });
        return;
    }
    if (typeof onBack === 'function') {
        onBack();
        return;
    }
    navigate(-1);
};
